module.exports = __webpack_public_path__ + "media/packs/users/img/icons/ArrowRight-3648290d060b0f97d9606776221e1bf8.svg";